var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWifiOnStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0.289509811,3.85784787 C0.640692749,4.2090308 1.19845389,4.2434605 1.57718058,3.92670727 C4.79291455,1.28250632 9.46158185,1.28250632 12.6842018,3.91982133 C13.0698144,4.23657456 13.6344615,4.2090308 13.9856444,3.85784787 C14.3919149,3.45157741 14.3643711,2.77675529 13.916785,2.41180047 C9.98491328,-0.803933491 4.29712687,-0.803933491 0.35836921,2.41180047 C-0.0892168876,2.76986935 -0.123646587,3.44469147 0.289509811,3.85784787 Z M5.63299922,9.20133728 L6.6452324,10.2135705 C6.91378406,10.4821221 7.34759828,10.4821221 7.61614994,10.2135705 L8.62838311,9.20133728 C8.95202229,8.8776981 8.88316289,8.31993696 8.47000649,8.10647283 C7.62992182,7.67265861 6.62457458,7.67265861 5.77760396,8.10647283 C5.38510539,8.31993696 5.30936005,8.8776981 5.63299922,9.20133728 Z M3.06454362,6.63288167 C3.40195468,6.97029273 3.93217205,7.00472243 4.32467063,6.72239889 C6.00483998,5.53113128 8.26342829,5.53113128 9.94359764,6.72239889 C10.3360962,6.99783649 10.8663136,6.97029273 11.2037247,6.63288167 L11.2106106,6.62599573 C11.623767,6.21283934 11.5962232,5.51047346 11.1210934,5.1730624 C8.75233003,3.45846335 5.52282419,3.45846335 3.1471749,5.1730624 C2.67204504,5.5173594 2.64450128,6.21283934 3.06454362,6.63288167 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#005082",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#005082",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-5 -7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifiOnStatus);
export default __webpack_public_path__ + "static/media/icon_wifi_on_status.ff3c05dc3ef97c86efc296bb666384d7.svg";
export { ForwardRef as ReactComponent };